import React from 'react';
import PropTypes from 'prop-types';

import { ConfirmModal } from '../../../../../components';
import './style.sass';

const DeleteProjectModal = ({
  isOpen,
  onCloseModal,
  project,
  onDeleteProject,
}) => (
  <ConfirmModal
    isOpen={isOpen}
    actionTitle="Delete"
    onAction={onDeleteProject}
    onClose={onCloseModal}
    title="Delete project"
  >
    <span className="text-size--sm">
      Are you sure you want to delete a
      {' '}
      <b>{project.title}</b>
?
    </span>
  </ConfirmModal>
);

DeleteProjectModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onCloseModal: PropTypes.func.isRequired,
  project: PropTypes.objectOf(PropTypes.object).isRequired,
  onDeleteProject: PropTypes.func.isRequired,
};

export default DeleteProjectModal;
